import { MARKETPLACE_IDS, type Connection, type MarketplaceId } from "./types";

export interface MarketplaceRow {
  marketplace: MarketplaceId;
  /** The row the operator acts on: active, else the most recent dead/disconnected
   *  shop (kept as context), else a synthetic not_connected. */
  primary: Connection;
  /** Older shops on this marketplace, newest first. Never rendered as rows. */
  previous: Connection[];
}

const RANK: Record<Connection["status"], number> = {
  active: 0,
  revoked: 1,
  expired: 1,
  disconnected: 2,
  not_connected: 3,
};

function newest(a: Connection, b: Connection): number {
  return (b.disconnected_at ?? b.connected_at ?? "").localeCompare(
    a.disconnected_at ?? a.connected_at ?? "",
  );
}

/**
 * One row per marketplace, fixed order. The backend returns every stored shop
 * (active and historical) as its own entry; this page shows the marketplace,
 * not the token history.
 */
export function groupByMarketplace(connections: Connection[]): MarketplaceRow[] {
  return MARKETPLACE_IDS.map((marketplace) => {
    const rows = connections
      .filter((c) => c.marketplace === marketplace)
      .sort((a, b) => RANK[a.status] - RANK[b.status] || newest(a, b));
    const primary = rows[0] ?? { marketplace, status: "not_connected" as const };
    const previous = rows.slice(1).filter((c) => c.shop_id);
    return { marketplace, primary, previous };
  });
}
